import angular from 'angular';
import { localStorage, options } from '../../utils';
import { includes, forEach, defaults, get } from 'lodash';
import 'angular-ui-tree';
import '../../services/organization-group';
import '../../services/errors';
import '../../services/globals';
import '../../services/line-flow-type-organization';
import '../../components/osom';
import Roles from '../../enums/roles';

const module = angular.module('whyline.modals.organization-group', [
  'whyline.services.organization-group',
  'whyline.services.errors',
  'whyline.services.globals',
  'whyline.services.line-flow-type-organization',
  'whyline.components.osom',
]);

const OrganizationGroupModalController = (
  $scope,
  $timeout,
  $uibModalInstance,
  $translate,
  NotificationService,
  OrganizationGroupService,
  organizationGroupId,
  ErrorService,
  LineFlowTypeOrganizationService,
  currentOrganization,
) => {
  'ngInject';
  $scope.blockSaveButton = false;
  $scope.currentOrganization = currentOrganization;
  $scope.organizationGroup = {
    label: '',
    configuration: {
      automaticCall: {
        enabled: true,
      },
      showAttentionTimer: true,
    },
  };
  $scope.displayModeCreate = true;
  $scope.title = '';
  $scope.items = [];

  $scope.lineFlowTypeOrganizationList = [];
  $scope.lineFlowTypeOrganizationSelected = {};
  $scope.organizationGroup.defaultLineFlowTypeOrganization = $scope.currentOrganization.defaultLineFlowTypeOrganization;

  $scope.setLFTOId = lftoSelected => {
    $scope.organizationGroup.defaultLineFlowTypeOrganization = lftoSelected._id;
  };

  const currentUser = localStorage.get('user');
  $scope.superAdmin = currentUser && currentUser.sudo;

  const permissions = get(currentUser, 'permissions', '');

  const isOrganizationAdmin = permissions.some(
    (permission) => Roles.organizationAdmin === permission.role.name,
  );
  $scope.canEditCallLogic = $scope.superAdmin || isOrganizationAdmin;

  const promiseLineFlowTypeOrganizationList = LineFlowTypeOrganizationService.GetAllEnabledByOrganization(
    $scope.currentOrganization._id,
    false,
  );

  const populateAlreadyShown = () => {
    $scope.itemsPopulated = {};
    forEach($scope.items, line => {
      $scope.itemsPopulated[line._id] = line;
    });
  };
  const createMirror = () => {
    $scope.organizationGroupUpdate = {
      label: '',
      organizationLines: [],
      lineFlowTypeOrganizationList: '',
      automaticCall: true,
      showAttentionTimer: true,
    };
  };

  const finishEdition = (prop) => {
    $scope.editStatus[prop] = false;
  };

  // Start generate options to partially save
  const generateOptions = () =>
    defaults(
      { options: options.filter((o) => o.onlyOrganizations || o.all) },
      { selectedOption: options.filter((o) => o.onlyOrganizations || o.all)[0].key },
    );
  $scope.selectDataForGroupName = generateOptions();
  $scope.selectDataForAddLines = generateOptions();
  $scope.selectDataForCallLogic = generateOptions();
  $scope.selectDataForCallType = generateOptions();
  // End generate options to partially save

  // Start editStatus
  $scope.editStatus = {
    editingGroupName: false,
    editingAddLines: false,
    editingCallLogic: false,
    editingCallType: false,
    editingAttentionTimer: false,
  };
  // End editStatus

  // Start save partial
  $scope.saveGroupName = async () => {
    const data = {
      updateType: $scope.selectDataForGroupName.selectedOption,
      updateValues: { label: $scope.organizationGroup.label },
    };
    const saved = await $scope.save(data);
    if (saved) {
      $scope.organizationGroupUpdate.label = $scope.organizationGroup.label;
      finishEdition('editingGroupName');
    }
  };

  $scope.saveAddLines = async () => {
    const data = {
      updateType: $scope.selectDataForAddLines.selectedOption,
      updateValues: { organizationLines: $scope.items.map((line) => line._id) },
    };
    const saved = await $scope.save(data);
    if (saved) {
      $scope.organizationGroupUpdate.organizationLines = $scope.items;
      finishEdition('editingAddLines');
    }
  };

  $scope.saveCallLogic = async () => {
    const data = {
      updateType: $scope.selectDataForCallLogic.selectedOption,
      updateValues: {
        defaultLineFlowTypeOrganization: $scope.organizationGroup.defaultLineFlowTypeOrganization,
      },
    };
    const saved = await $scope.save(data);
    if (saved) {
      $scope.lineFlowTypeOrganizationSelected = $scope.lineFlowTypeOrganizationList.find(
        (lfto) => lfto._id === $scope.organizationGroup.defaultLineFlowTypeOrganization,
      );
      $scope.organizationGroupUpdate.lineFlowTypeOrganizationList = $scope.organizationGroup.defaultLineFlowTypeOrganization;
      finishEdition('editingCallLogic');
    }
  };

  $scope.saveCallType = async () => {
    const data = {
      updateType: $scope.selectDataForCallType.selectedOption,
      updateValues: { configuration: $scope.organizationGroup.configuration },
    };
    const saved = await $scope.save(data);
    if (saved) {
      $scope.organizationGroupUpdate.automaticCall = $scope.organizationGroup.configuration.automaticCall.enabled;
      finishEdition('editingCallType');
    }
  };
  // End save partial

  $scope.saveAttentionTimer = async () => {
    const option = options.find((o) => o.onlyOrganizations).key;
    const data = {
      updateType: option,
      updateValues: {
        configuration: {
          showAttentionTimer: $scope.organizationGroup.configuration.showAttentionTimer,
        },
      },
    };
    const saved = await $scope.save(data);
    if (saved) {
      $scope.organizationGroupUpdate.showAttentionTimer = $scope.organizationGroup.configuration.showAttentionTimer;
      finishEdition('editingAttentionTimer');
    }
  };

  // Start Cancel Edit partial
  $scope.cancelEdit = (option) => {
    switch (option) {
      case 'groupName':
        $scope.organizationGroup.label = $scope.organizationGroupUpdate.label;
        finishEdition('editingGroupName');
        break;
      case 'addLines':
        finishEdition('editingAddLines');
        $scope.items = $scope.organizationGroupUpdate.organizationLines;
        break;
      case 'callLogic':
        $scope.organizationGroup.defaultLineFlowTypeOrganization = $scope.organizationGroupUpdate.lineFlowTypeOrganizationList;
        finishEdition('editingCallLogic');
        break;
      case 'callType':
        $scope.organizationGroup.configuration.automaticCall.enabled = $scope.organizationGroupUpdate.automaticCall;
        finishEdition('editingCallType');
        break;
      case 'attentionTimer':
        finishEdition('editingAttentionTimer');
        $scope.organizationGroup.configuration.showAttentionTimer = $scope.organizationGroupUpdate.showAttentionTimer;
        break;

      default:
        break;
    }
  };
  // End Cancel Edit partial

  const validate = () => {
    if (!$scope.organizationGroup.label) {
      NotificationService.Warning($translate.instant('name_mandatory'));
      return false;
    }
    if ($scope.organizationGroup.label.length > 50) {
      NotificationService.Warning($translate.instant('max_length_name'));
      return false;
    }

    if (!/^[ '-:A-Za-z\xC0-\xCF\xD1-\xD6\xD8-\xDD\xDF-\xE5\xE7-\xF6\xF8-\xFD\xFF\u0104-\u0107\u010C\u010D\u0116-\u0119\u012E\u012F\u0141-\u0144\u0152\u0160\u0161\u016A\u016B\u0172\u0173\u0178-\u017E]+$/.test($scope.organizationGroup.label)) {
      NotificationService.Warning($translate.instant('char_forbidden_name'));
      return false;
    }

    if ($scope.items.length <= 0) {
      NotificationService.Warning($translate.instant('min_fila_assign'));
      return false;
    }

    if (!$scope.organizationGroup.defaultLineFlowTypeOrganization) {
      NotificationService.Warning($translate.instant('mandatory_call_logic'));
      return false;
    }

    return true;
  };

  promiseLineFlowTypeOrganizationList.then((lftoList) => {
    $timeout(() => {
      $scope.lineFlowTypeOrganizationList = lftoList;
      let selectedLineFlowType = $scope.currentOrganization.defaultLineFlowTypeOrganization;
      let resourceLoaded = null;

      if (organizationGroupId) {
        $scope.title = `${$translate.instant('edit')}  ${$translate.instant('group')}`;
        $scope.displayModeCreate = false;
        createMirror();

        resourceLoaded = OrganizationGroupService.GetWithLinesAsPromiseFromServer(organizationGroupId)
          .then((res) => {
            $scope.organizationGroup = OrganizationGroupService.Copy(res);
            selectedLineFlowType = $scope.organizationGroup.defaultLineFlowTypeOrganization;

            $timeout(() => {
              $scope.linesPopulated = res.organizationLinesPopulated;
              $scope.organizationGroupUpdate.label = $scope.organizationGroup.label;
              $scope.organizationGroupUpdate.lineFlowTypeOrganizationList = $scope.organizationGroup.defaultLineFlowTypeOrganization;
              $scope.organizationGroupUpdate.automaticCall = $scope.organizationGroup.configuration.automaticCall.enabled;
              $scope.organizationGroupUpdate.showAttentionTimer = get($scope.organizationGroup, 'configuration.showAttentionTimer', false);
              // Fill item with lines
              for (let key in res.organizationLinesPopulated) {
                const item = {
                  label: res.organizationLinesPopulated[key].label,
                  _id: key,
                  type: res.organizationLinesPopulated[key].type,
                };
                $scope.items.push(item);
              }
              $scope.organizationGroupUpdate.organizationLines = $scope.items;
              populateAlreadyShown();
            });
          })
          .catch(ErrorService.handler);
      } else {
        resourceLoaded = Promise.resolve();
        $scope.displayModeCreate = true;
        $scope.title = `${$translate.instant('new')}  ${$translate.instant('group')}`;
      }

      resourceLoaded.then(() => {
        const found = $scope.lineFlowTypeOrganizationList.find(
          (lfto) => lfto._id === selectedLineFlowType,
        );

        $scope.lineFlowTypeOrganizationSelected = found ? found : $scope.lineFlowTypeOrganizationList[0];
      });
    });
  });

  $scope.save = (data) => {
    if (organizationGroupId && data) {
      if (validate()) {
        $scope.organizationGroup.organizationLines = $scope.items.map(item => item._id);
        $scope.blockSaveButton = true;
        const options = {};
        options.data = data;
        options.organizationGroupId = organizationGroupId;
        options.organizationId = $scope.organizationGroup.organizationId;

        return OrganizationGroupService.UpdatePartial(options)
          .then(() => {
            NotificationService.Success($translate.instant('group_update_succ').replace('{name}', $scope.organizationGroup.label));
          })
          .catch((error) => {
            if (
              (error.data === 'organization-line.line-with-enabled-portfolio' ||
                error.data === 'automatic_calling_must_be_disabled_to_continue') &&
              get(options, 'data.updateValues.configuration.automaticCall.enabled', false)
            ) {
              $scope.organizationGroup.configuration.automaticCall.enabled = false;
            }

            ErrorService.handler(error);
            $scope.blockSaveButton = false;
          });
      }
    } else {
      if (validate()) {
        $scope.organizationGroup.organizationLines = $scope.items.map(item => item._id);
        $scope.organizationGroup.lineFlowUpdateType = $scope.selectDataForCallLogic.selectedOption;

        $scope.blockSaveButton = true;

        return OrganizationGroupService.Create($scope.organizationGroup)
          .then(() => {
            NotificationService.Success($translate.instant('group_create_succ').replace('{name}', $scope.organizationGroup.label));
            $uibModalInstance.close('cancel');
            return true;
          })
          .catch(error => {
            ErrorService.handler(error);
            $scope.blockSaveButton = false;
            return false;
          });
      }
      return false;
    };
  };

  // OSOM line selector
  $scope.selectLine = selection => {
    const itemSelected = {
      label: selection.name,
      _id: selection._id,
      type: selection.type,
      //realType: selection.realType,
      //statistics: selection.statistics,
      //waitingPeople: selection.waitingPeople
    };
    if (!includes($scope.items.map(item => item._id), selection._id)) {
      $scope.items.push(itemSelected);
    }
    populateAlreadyShown();
  };

  $scope.removeLine = lineId => {
    $scope.items = $scope.items.filter(item => item._id !== lineId);
    populateAlreadyShown();
  };

  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  $scope.validateNumber = () => {
    let number = parseInt($scope.organizationGroup.maxNumbers);
    number = isNaN(number) ? 0 : number;
    $scope.organizationGroup.maxNumbers = number;
  };

  $scope.maxNumberKeyPress = e => {
    if (e.keyCode === 101 || e.keyCode === 69) {
      e.preventDefault();
    }
  };
};

module.exports = module.controller('OrganizationGroupModalController', OrganizationGroupModalController);
